import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-submission-detail',
  templateUrl: './submission-detail.component.html',
  styleUrls: ['./submission-detail.component.css']
})
export class SubmissionDetailComponent implements OnInit {
  modalRef: BsModalRef;
  intimationNo: string;
  submissionSuccessfull: boolean = false;
  showModal = false;
  // openingPopup: boolean = false;
  loading: boolean;
  claimInfo: any;
  error: string;
  employeeName: string;
  mobileNo: string;
  corporateName: string;
  insurer: string;
  policyNumber: string;
  claimant: string;
  relationWithEmployee: string;
  cardNumber: string;
  email: string;
  productType: string;
  ailment: string;
  hospitalState: string;
  hospitalCity: string;
  hospitalName: string;
  estimatedAmount: string;
  admissionDate: string;
  dischargeDate: string;
  dateOfBirth: string;
  registeredDate: string;
  claimFormUrl: string;
  claimsFormRepoId: number;

  selectedFile: File;
  attachImage: File;
  selectedFileName: string;
  policyId: any;
  fileArray = [];
  fileNameArray = [];
  uploader: any;
  uploading: boolean;
  eclaimsId: string;
  insurerId:any;
  tpaId:any;
  isMailButton:boolean=true;

  cliamDocuments: Array<any> = [];
  claismId = 1;

  claimsForms = [];
  hospitalBills = [];
  doctorsPresriptions = [];
  paidRecipts = [];
  diagnosticReports = [];
  implantStickers = [];
  neftDetails = [];
  dischargeSummaryDetails = [];
  otherDetails = [];
  private onDestroy$: Subject<void> = new Subject<void>();

  supportedExtensions = ['jpeg', 'jpg', 'png', 'zip', 'pdf', 'doc', 'dox', 'xls', 'xlsx'];

  private filesToUpload = null;
  private hospitalBillToUpload = null;
  private doctorsPrescriptionToUpload = null;
  private paidReceiptsToUpload = null;
  private diagnosticReportsToUpload = null;
  private implantStickersToUpload = null;
  private neftDetailsToUpload = null;
  private dischargeDetailsToUpload = null;
  private otherDetailsToUpload = null;

  public message = '';


  constructor(private router: Router, private serviceURLService: serviceURLService, private modalService: BsModalService,) { }

  ngOnInit() {
    this.getClaimDetailByIntimationNo();
    this.getUploadedDocumentsByIntimationNo();
  }

  getClaimDetailByIntimationNo() {
    var url = window.location.pathname
    this.intimationNo = url.substr(url.lastIndexOf('/') + 1);

    this.loading = true;
    this.serviceURLService.getClaimInfoByIntimationNo(this.intimationNo).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      this.claimInfo = successData.response.pamResponse.data;
      for (var i = 0; i < this.claimInfo.length; i++) {
        this.employeeName = this.claimInfo[i].employeeName ? this.claimInfo[i].employeeName : '-';
        this.mobileNo = this.claimInfo[i].mobileNo ? this.claimInfo[i].mobileNo : '-';
        this.corporateName = this.claimInfo[i].corporateName ? this.claimInfo[i].corporateName : '-';
        this.insurer = this.claimInfo[i].insurer ? this.claimInfo[i].insurer : '-';
        this.policyNumber = this.claimInfo[i].policyNumber ? this.claimInfo[i].policyNumber : '-';
        this.claimant = this.claimInfo[i].claimant ? this.claimInfo[i].claimant : '-';
        this.relationWithEmployee = this.claimInfo[i].relationWithEmployee ? this.claimInfo[i].relationWithEmployee : '-';
        this.cardNumber = this.claimInfo[i].cardNumber ? this.claimInfo[i].cardNumber : '-';
        this.email = this.claimInfo[i].email ? this.claimInfo[i].email : '-';
        this.productType = this.claimInfo[i].productType ? this.claimInfo[i].productType : '-';
        this.ailment = this.claimInfo[i].ailment ? this.claimInfo[i].ailment : '-';
        this.hospitalState = this.claimInfo[i].hospitalState ? this.claimInfo[i].hospitalState : '-';
        this.hospitalCity = this.claimInfo[i].hospitalCity ? this.claimInfo[i].hospitalCity : '-';
        this.hospitalName = this.claimInfo[i].hospitalName ? this.claimInfo[i].hospitalName : '-';
        this.estimatedAmount = this.claimInfo[i].estimatedAmount ? this.claimInfo[i].estimatedAmount : '-';
        this.admissionDate = this.claimInfo[i].admissionDate ? this.claimInfo[i].admissionDate : '-';
        this.dischargeDate = this.claimInfo[i].dischargeDate ? this.claimInfo[i].dischargeDate : '-';
        this.dateOfBirth = this.claimInfo[i].dateOfBirth ? this.claimInfo[i].dateOfBirth : '-';
        this.registeredDate = this.claimInfo[i].dateCreated ? this.claimInfo[i].dateCreated : '-';
        this.claimFormUrl = this.claimInfo[i].claimFormUrl ? this.claimInfo[i].claimFormUrl : '-';
        this.insurerId=this.claimInfo[i].insurerId;
        this.tpaId=this.claimInfo[i].tpaId;
        this.claimsFormRepoId = this.claimInfo[i].claimsFormRepoId ? this.claimInfo[i].claimsFormRepoId : null;
      }

    }, errorData => {
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  viewDetails() {
    document.getElementById("viewMoreEclaimsData").removeAttribute("hidden");
    document.getElementById("viewMoreEclaimsButton").setAttribute('hidden', 'hidden');
  }

  getUploadedDocumentsByIntimationNo() {
    var url = window.location.pathname
    this.intimationNo = url.substr(url.lastIndexOf('/') + 1);

    this.serviceURLService.getDocumentsByIntimationNo(this.intimationNo).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.cliamDocuments = successData.response.pamResponse.data;
      for (var i = 0; i < this.cliamDocuments.length; i++) {
        if (this.cliamDocuments[i].documentId == 1) {
          document.getElementById("previouslyUploadedClaimForm").removeAttribute("hidden");
        } else if (this.cliamDocuments[i].documentId == 2) {
          document.getElementById("previouslyUploadedHospitalBills").removeAttribute("hidden");
        } else if (this.cliamDocuments[i].documentId == 3) {
          document.getElementById("previouslyUploadedDoctorsPrescription").removeAttribute("hidden");
        } else if (this.cliamDocuments[i].documentId == 4) {
          document.getElementById("previouslyUploadedPaidReciepts").removeAttribute("hidden");
        } else if (this.cliamDocuments[i].documentId == 5) {
          document.getElementById("previouslyUploadedDiagnosticReports").removeAttribute("hidden");
        } else if (this.cliamDocuments[i].documentId == 6) {
          document.getElementById("previouslyUploadedImplantStickers").removeAttribute("hidden");
        } else if (this.cliamDocuments[i].documentId == 7) {
          document.getElementById("previouslyUploadedNefts").removeAttribute("hidden");
        } else if (this.cliamDocuments[i].documentId == 8) {
          document.getElementById("previouslyUploadedDischargeSummary").removeAttribute("hidden");
        } else if (this.cliamDocuments[i].documentId == 9) {
          document.getElementById("previouslyUploadedOthers").removeAttribute("hidden");
        }
      }
    }, errorData => {
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    });
  }

  refresh(): void {
    window.location.reload();
  }

  deleteDocByClaimDocumentId(claimDocId, index) {
    this.serviceURLService.deleteDocumentByClaimsDocId(claimDocId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      console.log("File deleted successfully..!!");
      this.cliamDocuments.splice(index, 1);
    });

  }

  checkFileSize(uploadedFileName, uploadedFileSize) {
    const path = uploadedFileName.split('.');
    const extension = `${path[path.length - 1]}`;
    if (this.supportedExtensions.includes(extension)) {
      if (uploadedFileSize < 10000 || uploadedFileSize > 50000000) {
        var toaster = document.getElementById("snackbar");
        toaster.innerHTML = "File should be more than 10KB and less than 50MB in size";
        toaster.className = "show";
        setTimeout(function () { toaster.className = toaster.className.replace("show", ""); }, 3000);
        return false;
        /* For max and min file size end */
      } else {
        this.uploading = true;
        return true;
      }
    }
  }

  claimForm(files) {
    this.message = '';
    this.filesToUpload = files;
    if (files.length != null) {
      for (let i = 0; i < files.length; i++) {
        var uploadedFileName = files.item(i).name;
        var uploadedFileSize = files.item(i).size;
        // for file size check
        this.checkFileSize(uploadedFileName, uploadedFileSize);
        if (this.checkFileSize(uploadedFileName, uploadedFileSize) === true) {
          this.fileNameArray.push(uploadedFileName);
          setTimeout(() => { this.uploading = false; }, 1000);
        }
      }

    }
  }

  hospitalBill(bills) {
    this.hospitalBillToUpload = bills;
    for (let i = 0; i < bills.length; i++) {
      if (bills.length > 0) {
        var uploadedFileName = bills.item(i).name;
        var uploadedFileSize = bills.item(i).size;
        // for file size check
        this.checkFileSize(uploadedFileName, uploadedFileSize);
        if (this.checkFileSize(uploadedFileName, uploadedFileSize) === true) {
          this.hospitalBills.push(uploadedFileName);
          setTimeout(() => { this.uploading = false; }, 1000);
        }
      }
    }
  }

  doctorsPrescription(prescriptions) {
    this.doctorsPrescriptionToUpload = prescriptions;
    for (let i = 0; i < prescriptions.length; i++) {
      if (prescriptions.length > 0) {
        var uploadedFileName = prescriptions.item(i).name;
        var uploadedFileSize = prescriptions.item(i).size;
        // for file size check
        this.checkFileSize(uploadedFileName, uploadedFileSize);
        if (this.checkFileSize(uploadedFileName, uploadedFileSize) === true) {
          this.doctorsPresriptions.push(uploadedFileName);
          setTimeout(() => { this.uploading = false; }, 1000);
        }
      }
    }
  }

  paidReceipt(recipts) {
    this.paidReceiptsToUpload = recipts;
    for (let i = 0; i < recipts.length; i++) {
      if (recipts.length > 0) {
        var uploadedFileName = recipts.item(i).name;
        var uploadedFileSize = recipts.item(i).size;
        // for file size check
        this.checkFileSize(uploadedFileName, uploadedFileSize);
        if (this.checkFileSize(uploadedFileName, uploadedFileSize) === true) {
          this.paidRecipts.push(uploadedFileName);
          setTimeout(() => { this.uploading = false; }, 1000);
        }
      }
    }
  }

  diagnosticReport(reports) {
    this.diagnosticReportsToUpload = reports;
    for (let i = 0; i < reports.length; i++) {
      if (reports.length > 0) {
        var uploadedFileName = reports.item(i).name;
        var uploadedFileSize = reports.item(i).size;
        // for file size check
        this.checkFileSize(uploadedFileName, uploadedFileSize);
        if (this.checkFileSize(uploadedFileName, uploadedFileSize) === true) {
          this.diagnosticReports.push(uploadedFileName);
          setTimeout(() => { this.uploading = false; }, 1000);
        }
      }
    }
  }

  implantSticker(stickers) {
    this.implantStickersToUpload = stickers;
    for (let i = 0; i < stickers.length; i++) {
      if (stickers.length > 0) {
        var uploadedFileName = stickers.item(i).name;
        var uploadedFileSize = stickers.item(i).size;
        // for file size check
        this.checkFileSize(uploadedFileName, uploadedFileSize);
        if (this.checkFileSize(uploadedFileName, uploadedFileSize) === true) {
          this.implantStickers.push(uploadedFileName);
          setTimeout(() => { this.uploading = false; }, 1000);
        }
      }
    }
  }

  neftDetail(nefts) {
    this.neftDetailsToUpload = nefts;
    for (let i = 0; i < nefts.length; i++) {
      if (nefts.length > 0) {
        var uploadedFileName = nefts.item(i).name;
        var uploadedFileSize = nefts.item(i).size;
        // for file size check
        this.checkFileSize(uploadedFileName, uploadedFileSize);
        if (this.checkFileSize(uploadedFileName, uploadedFileSize) === true) {
          this.neftDetails.push(uploadedFileName);
          setTimeout(() => { this.uploading = false; }, 1000);
        }
      }
    }
  }

  dischargeDetail(summary) {
    this.dischargeDetailsToUpload = summary;
    for (let i = 0; i < summary.length; i++) {
      if (summary.length > 0) {
        var uploadedFileName = summary.item(i).name;
        var uploadedFileSize = summary.item(i).size;
        // for file size check
        this.checkFileSize(uploadedFileName, uploadedFileSize);
        if (this.checkFileSize(uploadedFileName, uploadedFileSize) === true) {
          this.dischargeSummaryDetails.push(uploadedFileName);
          setTimeout(() => { this.uploading = false; }, 1000);
        }
      }
    }
  }

  otherDetail(others) {
    this.otherDetailsToUpload = others;
    for (let i = 0; i < others.length; i++) {
      if (others.length > 0) {
        var uploadedFileName = others.item(i).name;
        var uploadedFileSize = others.item(i).size;
        // for file size check
        this.checkFileSize(uploadedFileName, uploadedFileSize);
        if (this.checkFileSize(uploadedFileName, uploadedFileSize) === true) {
          this.otherDetails.push(uploadedFileName);
          console.log(this.otherDetails);
          setTimeout(() => { this.uploading = false; }, 1000);
        }
      }
    }
  }

  upload() {
    this.loading = true;
    var url = window.location.pathname
    this.intimationNo = url.substr(url.lastIndexOf('/') + 1);
    this.eclaimsId = this.intimationNo;
    const formData = new FormData();
    const files = this.filesToUpload;
    const bills = this.hospitalBillToUpload;
    const prescriptions = this.doctorsPrescriptionToUpload;
    const recipts = this.paidReceiptsToUpload;
    const reports = this.diagnosticReportsToUpload;
    const stickers = this.implantStickersToUpload;
    const nefts = this.neftDetailsToUpload;
    const summary = this.dischargeDetailsToUpload;
    const others = this.otherDetailsToUpload;

    // console.log(files);

    //for claim form
    if (files != null) {
      for (let i = 0; i < files.length; i++) {
        if (files.length > 0) {
          let fileReader = new FileReader();
          fileReader.onload = (e) => {
          }
          fileReader.readAsText(files.item(i));
          formData.append("1", files.item(i), files.item(i).name);
        }
      }
    }


    //for hospital bills
    if (bills != null) {
      for (let i = 0; i < bills.length; i++) {
        if (bills.length > 0) {
          let fileReader = new FileReader();
          fileReader.onload = (e) => {
            // console.log(fileReader.result);
          }
          fileReader.readAsText(bills.item(i));
          formData.append("2", bills.item(i), bills.item(i).name);
        }
      }
    }


    //for Doctor's Prescription
    if (prescriptions != null) {
      for (let i = 0; i < prescriptions.length; i++) {
        if (prescriptions.length > 0) {
          let fileReader = new FileReader();
          fileReader.onload = (e) => {
            // console.log(fileReader.result);
          }
          fileReader.readAsText(prescriptions.item(i));
          formData.append("3", prescriptions.item(i), prescriptions.item(i).name);
        }
      }
    }

    //for Paid Receipts
    if (recipts != null) {
      for (let i = 0; i < recipts.length; i++) {
        if (recipts.length > 0) {
          let fileReader = new FileReader();
          fileReader.onload = (e) => {
            // console.log(fileReader.result);
          }
          fileReader.readAsText(recipts.item(i));
          formData.append("4", recipts.item(i), recipts.item(i).name);
        }
      }
    }


    //for Diagnostic Reports
    if (reports != null) {
      for (let i = 0; i < reports.length; i++) {
        if (recipts.length > 0) {
          let fileReader = new FileReader();
          fileReader.onload = (e) => {
            // console.log(fileReader.result);
          }
          fileReader.readAsText(reports.item(i));
          formData.append("5", reports.item(i), reports.item(i).name);
        }
      }
    }


    //for Implant Stickers
    if (stickers != null) {
      for (let i = 0; i < stickers.length; i++) {
        if (stickers.length > 0) {
          let fileReader = new FileReader();
          fileReader.onload = (e) => {
            // console.log(fileReader.result);
          }
          fileReader.readAsText(stickers.item(i));
          formData.append("6", stickers.item(i), stickers.item(i).name);
        }
      }
    }

    //for NEFT Details(Cancelled cheques)
    if (nefts != null) {
      for (let i = 0; i < nefts.length; i++) {
        let fileReader = new FileReader();
        if (nefts.length > 0) {
          fileReader.onload = (e) => {
            // console.log(fileReader.result);
          }
          fileReader.readAsText(nefts.item(i));
          formData.append("7", nefts.item(i), nefts.item(i).name);
        }
      }
    }

    //for Discharge Summary
    if (summary != null) {
      for (let i = 0; i < summary.length; i++) {
        let fileReader = new FileReader();
        if (summary.length > 0) {
          fileReader.onload = (e) => {
            // console.log(fileReader.result);
          }
          fileReader.readAsText(summary.item(i));
          formData.append("8", summary.item(i), summary.item(i).name);
        }
      }
    }

    //for Other Details
    if (others != null) {
      for (let i = 0; i < others.length; i++) {
        let fileReader = new FileReader();
        if (others.length > 0) {
          fileReader.onload = (e) => {
            // console.log(fileReader.result);
          }
          fileReader.readAsText(others.item(i));
          formData.append("9", others.item(i), others.item(i).name);
        }
      }
    }

    if (files != null || bills != null || prescriptions != null || recipts != null || reports != null || stickers != null || nefts != null || summary != null || others != null) {
      this.serviceURLService.uploadDocument(formData, this.eclaimsId).subscribe((successData: any) => {
        this.isMailButton=false;
        const uploadDocumentResponse = successData.data;
        setTimeout(function () {
            }, 9000);
            this.loading = false;
        
      });
    } else {
      var toaster = document.getElementById("uploadFileError");
      toaster.innerHTML = "Please upload atleast 1 file.";
      toaster.className = "show";
      setTimeout(function () { toaster.className = toaster.className.replace("show", ""); }, 3000);
      this.loading = false;
    }
    
  }

  removeSelectedFile(event, index) {
    console.log(event + index);
    // Delete the item from fileNames list

    if (index == 'claimForm') {
      this.fileNameArray.splice(index, 1);
    } else if (index == 'bill') {
      this.hospitalBills.splice(index, 1);
    } else if (index == 'prescriptions') {
      this.doctorsPresriptions.splice(index, 1);
    } else if (index == 'receipt') {
      this.paidRecipts.splice(index, 1);
    } else if (index == 'report') {
      this.diagnosticReports.splice(index, 1);
    } else if (index == 'sticker') {
      this.implantStickers.splice(index, 1);
    } else if (index == 'neft') {
      this.neftDetails.splice(index, 1);
    } else if (index == 'dischargeSummary') {
      this.dischargeSummaryDetails.splice(index, 1);
    } else if (index == 'other') {
      this.otherDetails.splice(index, 1);
    }

    // delete file from FileList
    this.fileArray.splice(index, 1);
  }

//for submit and send mail api 

senMailOnSubmit() {
  this.loading = true;
  this.isMailButton=true;
  this.serviceURLService.sendMailOnClaimSubmit(this.intimationNo,this.insurerId,this.tpaId).subscribe((successData: any) => {
    this.submissionSuccessfull = true;
    this.loading = false;
  }, errorData => {
    if (errorData.error.status === 403) {
      this.error = errorData.error.message;
    }
  })
}

// fow download of claim form
downloadClaimForm() {
  this.loading = true;
  this.serviceURLService.downloadClaimForm(this.claimsFormRepoId).subscribe((successData: any) => {
    this.loading = false;
    if(successData.url){
      window.open(successData.url, '_self')
    }
  }, errorData => {
    this.loading = false;
    if(errorData.status === 200 && errorData.url){
      window.open(errorData.url, '_self')
    }
    else{
      console.log(errorData)
    }
  })
}


ngOnDestroy(): void {
  this.onDestroy$.next();
  this.onDestroy$.complete();
}
}